import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { SubmissionsDashboard } from '@LTIDashboard/modules/SubmissionsDashboard'
import { GeneralDashboard } from '@LTIDashboard/modules/GeneralDashboard'
import {
  AssessmentsProvider,
  ResourcesProvider,
} from '@LTIDashboard/state'
import { ConnectionProvider } from '@LTIDashboard/state'
import { ErrorBoundary } from '@CommonComponents'

export function App() {

  return (
    <ErrorBoundary>
      <ConnectionProvider>
        <ResourcesProvider>
          <AssessmentsProvider>
              <Router>
                <Switch>
                  <Route
                    exact
                    path="/instructor/lti_dashboard/:coursenum"
                    component={GeneralDashboard}
                  />
                  <Route
                    path="/instructor/lti_dashboard/:coursenum/:assessment_pk"
                    component={SubmissionsDashboard}
                  />
                </Switch>
              </Router>
          </AssessmentsProvider>
        </ResourcesProvider>
      </ConnectionProvider>
    </ErrorBoundary>
  )
}
